var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65525 7.99976L5.58634 4.93085C5.30716 4.65167 5.30716 4.19903 5.58634 3.91985C5.86552 3.64067 6.31816 3.64067 6.59733 3.91985L10.1718 7.49427C10.4509 7.77344 10.4509 8.22608 10.1718 8.50526L6.59733 12.0797C6.31816 12.3589 5.86552 12.3589 5.58634 12.0797C5.30716 11.8005 5.30716 11.3479 5.58634 11.0687L8.65525 7.99976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.51492083faab78a9815081b9e185efd2.svg";
export { ForwardRef as ReactComponent };